<template lang="pug">
  b-modal(
    id="modal-cotization"
    :visible="showModal"
    size="xl"
    @hide="handleModalClose"
    no-close-on-backdrop
  )
    template(#modal-title)
      .cotizacion-title-wrapper
        .cotizacion-title-main Generar Cotización
        .cotizacion-title-id ID {{ item.id }}
    template(#modal-footer)
      div.mt-5
    div
      GenerarCotizacion(:item="item" :showModal="showModal", v-if="showModal" type="complete")
  </template>

<script>
import Autocomplete from '@trevoreyre/autocomplete-vue'
import GenerarCotizacion from './generarCotizacion.vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'

export default {
  name: 'ModalCotization',
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
  },
  components: {
    Autocomplete,
    GenerarCotizacion
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    precioPVPFormateado() {
      const precio = this.item?.datos_equipo?.precio_pvp
      if (!precio || precio === 0) return ''
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        minimumFractionDigits: 0,
      }).format(precio)
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    handleModalClose() {
      this.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep .modal-xl {
    max-width: 90vw !important;
  }
  
  @media (min-width: 1400px) {
    ::v-deep .modal-xl {
      max-width: 1600px !important;
    }
  }

  .cotizacion-title-wrapper {
    display: flex;
    flex-direction: column;
  }

  .cotizacion-title-main {
    font-family: 'Noto Sans', sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: #23201c;
    line-height: 27px;
  }

  .cotizacion-title-row {
    display: flex;
    align-items: baseline;
    gap: 30px;
    flex-wrap: wrap;
  }

  .cotizacion-title-id {
    font-family: 'Noto Sans', sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: #23201c;
    line-height: 27px;
  }

  .pvp-title-text {
    font-family: 'Noto Sans', sans-serif;
    font-size: 20px;
    font-weight: 700;
    font-style: italic;
    color: #23201c;
    line-height: 27px;
  }
</style>
